'use strict'

function _typeof(obj) {
  '@babel/helpers - typeof'
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof = function _typeof(obj) {
      return typeof obj
    }
  } else {
    _typeof = function _typeof(obj) {
      return obj &&
        typeof Symbol === 'function' &&
        obj.constructor === Symbol &&
        obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj
    }
  }
  return _typeof(obj)
}

Object.defineProperty(exports, '__esModule', {
  value: true,
})
exports.TextField =
  exports.StyledValue =
  exports.PrintedTextField =
  exports.PrintedTextAreaField =
  exports.PrintedSSNField =
  exports.PrintedPhoneField =
    void 0

require('cleave.js/dist/addons/cleave-phone.us')

var _react = _interopRequireDefault(require('cleave.js/react'))

var _react2 = _interopRequireWildcard(require('react'))

var _styledComponents = _interopRequireWildcard(require('styled-components'))

var _index = require('../../atoms/Label/index.js')

var _index2 = require('../../atoms/Typography/index.js')

var _conversion = require('../../utils/conversion.js')

var _index3 = require('../Flex/index.js')

var _excluded = [
  'id',
  'as',
  'Icon',
  'label',
  'error',
  'onSave',
  'onChange',
  'saving',
  'required',
  'autoComplete',
  'subLabel',
  'disabled',
  'onBlur',
  'onFocus',
  'margin',
  'value',
  'customcss',
  'noIcons',
  'formatType',
  'inputClassName',
  'fieldId',
  'checkAutoFills',
  'wasAutoFilled',
  'addToAutoFillList',
  'runValidation',
]

var _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5,
  _templateObject6,
  _templateObject7,
  _templateObject8,
  _templateObject9,
  _templateObject10,
  _templateObject11

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== 'function') return null
  var cacheBabelInterop = new WeakMap()
  var cacheNodeInterop = new WeakMap()
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop
  })(nodeInterop)
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj
  }
  if (obj === null || (_typeof(obj) !== 'object' && typeof obj !== 'function')) {
    return { default: obj }
  }
  var cache = _getRequireWildcardCache(nodeInterop)
  if (cache && cache.has(obj)) {
    return cache.get(obj)
  }
  var newObj = {}
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor
  for (var key in obj) {
    if (key !== 'default' && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc)
      } else {
        newObj[key] = obj[key]
      }
    }
  }
  newObj['default'] = obj
  if (cache) {
    cache.set(obj, newObj)
  }
  return newObj
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

function _extends() {
  _extends =
    Object.assign ||
    function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i]
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key]
          }
        }
      }
      return target
    }
  return _extends.apply(this, arguments)
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object)
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object)
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable
      })
    }
    keys.push.apply(keys, symbols)
  }
  return keys
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {}
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key])
      })
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key))
      })
    }
  }
  return target
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    })
  } else {
    obj[key] = value
  }
  return obj
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg)
    var value = info.value
  } catch (error) {
    reject(error)
    return
  }
  if (info.done) {
    resolve(value)
  } else {
    Promise.resolve(value).then(_next, _throw)
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args)
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, 'next', value)
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, 'throw', err)
      }
      _next(undefined)
    })
  }
}

function _toConsumableArray(arr) {
  return (
    _arrayWithoutHoles(arr) ||
    _iterableToArray(arr) ||
    _unsupportedIterableToArray(arr) ||
    _nonIterableSpread()
  )
}

function _nonIterableSpread() {
  throw new TypeError(
    'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
  )
}

function _iterableToArray(iter) {
  if (
    (typeof Symbol !== 'undefined' && iter[Symbol.iterator] != null) ||
    iter['@@iterator'] != null
  )
    return Array.from(iter)
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr)
}

function _slicedToArray(arr, i) {
  return (
    _arrayWithHoles(arr) ||
    _iterableToArrayLimit(arr, i) ||
    _unsupportedIterableToArray(arr, i) ||
    _nonIterableRest()
  )
}

function _nonIterableRest() {
  throw new TypeError(
    'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
  )
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return
  if (typeof o === 'string') return _arrayLikeToArray(o, minLen)
  var n = Object.prototype.toString.call(o).slice(8, -1)
  if (n === 'Object' && o.constructor) n = o.constructor.name
  if (n === 'Map' || n === 'Set') return Array.from(o)
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen)
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i]
  }
  return arr2
}

function _iterableToArrayLimit(arr, i) {
  var _i =
    arr == null
      ? null
      : (typeof Symbol !== 'undefined' && arr[Symbol.iterator]) || arr['@@iterator']
  if (_i == null) return
  var _arr = []
  var _n = true
  var _d = false
  var _s, _e
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value)
      if (i && _arr.length === i) break
    }
  } catch (err) {
    _d = true
    _e = err
  } finally {
    try {
      if (!_n && _i['return'] != null) _i['return']()
    } finally {
      if (_d) throw _e
    }
  }
  return _arr
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {}
  var target = _objectWithoutPropertiesLoose(source, excluded)
  var key, i
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source)
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i]
      if (excluded.indexOf(key) >= 0) continue
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue
      target[key] = source[key]
    }
  }
  return target
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {}
  var target = {}
  var sourceKeys = Object.keys(source)
  var key, i
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i]
    if (excluded.indexOf(key) >= 0) continue
    target[key] = source[key]
  }
  return target
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0)
  }
  return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }))
}

var ErrorIcon = function ErrorIcon(props) {
  return /*#__PURE__*/ _react2['default'].createElement(
    'svg',
    props,
    /*#__PURE__*/ _react2['default'].createElement('path', {
      d: 'M13.5 0C6.056 0 0 6.056 0 13.5S6.056 27 13.5 27 27 20.944 27 13.5 20.944 0 13.5 0z',
      fill: '#DA6C6C',
    }),
    /*#__PURE__*/ _react2['default'].createElement('path', {
      d: 'M13.682 12.349L9.007 7.674 7.674 9.007l4.675 4.675-4.675 4.674 1.333 1.333 4.675-4.675 4.674 4.675 1.333-1.333-4.674-4.674 4.674-4.675-1.333-1.333-4.674 4.675z',
      fill: '#fff',
    })
  )
}

ErrorIcon.defaultProps = {
  width: '27',
  height: '27',
  viewBox: '0 0 27 27',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
}

var SuccessIcon = function SuccessIcon(props) {
  return /*#__PURE__*/ _react2['default'].createElement(
    'svg',
    props,
    /*#__PURE__*/ _react2['default'].createElement('path', {
      d: 'M13.5 0C6.056 0 0 6.056 0 13.5S6.056 27 13.5 27 27 20.944 27 13.5 20.944 0 13.5 0z',
      fill: '#74C270',
    }),
    /*#__PURE__*/ _react2['default'].createElement('path', {
      d: 'M20.342 10.639L13.03 17.95a1.122 1.122 0 0 1-1.59 0l-3.657-3.656a1.123 1.123 0 1 1 1.59-1.59l2.861 2.86 6.518-6.517a1.124 1.124 0 1 1 1.59 1.59z',
      fill: '#FAFAFA',
    })
  )
}

SuccessIcon.defaultProps = {
  width: '27',
  height: '27',
  viewBox: '0 0 27 27',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
}

/*function aaa(a: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
  return ''
}*/
//aaa('' as unknown as React.ChangeEvent<HTMLInputElement>)
var SavingIndicator = _styledComponents['default'].div(
  _templateObject ||
    (_templateObject = _taggedTemplateLiteral([
      '\n  display: flex;\n  border-radius: 16px;\n  top: 0;\n  right: ',
      ';\n  padding: ',
      ';\n  background-color: #b0adad;\n  color: #fff;\n',
    ])),
  function (props) {
    return props.theme.spacing(2)
  },
  function (props) {
    return ''.concat(props.theme.spacing(0.5), ' ').concat(props.theme.spacing(1))
  }
)

var InputIcon = _styledComponents['default'].div(
  _templateObject2 ||
    (_templateObject2 = _taggedTemplateLiteral([
      '\n  position: absolute;\n  top: 0;\n  display: flex;\n  align-items: center;\n  height: 100%;\n  right: ',
      ';\n',
    ])),
  function (props) {
    return props.theme.spacing(2)
  }
)

var CustomIconContainer = _styledComponents['default'].div(
  _templateObject3 ||
    (_templateObject3 = _taggedTemplateLiteral([
      '\n  position: absolute;\n  top: 0;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  right: ',
      ';\n',
    ])),
  function (props) {
    return props.theme.spacing(2)
  }
)

var ErrorContainer = (0, _styledComponents['default'])(_index3.Flex)(
  _templateObject4 || (_templateObject4 = _taggedTemplateLiteral(['\n  ', '\n'])),
  function (props) {
    return props.error ? '' : 'display: none;'
  }
)
// Just use track
var onAutoFillStart = (0, _styledComponents.keyframes)(
  _templateObject5 ||
    (_templateObject5 = _taggedTemplateLiteral([
      '\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 1;\n  }\n',
    ]))
)
var InputStyles = (0, _styledComponents.css)(
  _templateObject6 ||
    (_templateObject6 = _taggedTemplateLiteral([
      '\n  width: ',
      ';\n  height: ',
      ';\n  border: 0;\n  border-radius: 5px;\n  font-size: 16px; /* fixed font size to prevent iOS from zooming on inputs */\n  padding-left: ',
      ';\n  padding-right: ',
      ';\n  padding: ',
      ';\n  border: ',
      ';\n  background-color: ',
      ';\n  transition: background-color 0.1s, border-width 0.1s;\n  &:-webkit-autofill {\n    animation: ',
      ' 1s linear;\n  }\n  &:focus {\n    outline: 0;\n    background-color: ',
      ';\n    border: none;\n    border-bottom: 3px solid\n      ',
      ';\n  }\n  &:disabled {\n    opacity: 0.6;\n  }\n',
    ])),
  function (props) {
    return props.width || '100%'
  },
  function (props) {
    return props.height || '100%'
  },
  function (props) {
    return props.theme.spacing(2)
  },
  function (props) {
    return props.theme.spacing(2)
  },
  function (props) {
    return props.padding ? props.padding : ''
  },
  function (props) {
    return props.border ? '1px solid #c2c2c2' : 'none'
  },
  function (props) {
    return props.error
      ? props.theme.lighten(props.theme.colors.error)
      : props.white
      ? '#FFF'
      : props.theme.colors.input.background
  },
  onAutoFillStart,
  function (props) {
    return props.error
      ? props.theme.lighten(props.theme.colors.error)
      : props.theme.lighten(props.theme.colors.primary)
  },
  function (props) {
    return props.error
      ? props.theme.lighten(props.theme.colors.error)
      : props.theme.lighten(props.theme.colors.primary)
  }
)

var StyledTextarea = _styledComponents['default'].textarea(
  _templateObject7 ||
    (_templateObject7 = _taggedTemplateLiteral([
      '\n  ',
      ';\n  resize: none;\n  padding-top: ',
      ';\n',
    ])),
  function (props) {
    return props.customcss || InputStyles
  },
  function (props) {
    return props.theme.spacing(1.5)
  }
)

var StyledInput = (0, _styledComponents['default'])(_react['default'])(
  _templateObject8 || (_templateObject8 = _taggedTemplateLiteral(['\n  ', ';\n'])),
  function (props) {
    return props.customcss || InputStyles
  }
)

var TextField = function TextField(_ref) {
  var id = _ref.id,
    as = _ref.as,
    Icon = _ref.Icon,
    label = _ref.label,
    error = _ref.error,
    onSave = _ref.onSave,
    _onChange = _ref.onChange,
    saving = _ref.saving,
    required = _ref.required,
    _ref$autoComplete = _ref.autoComplete,
    autoComplete = _ref$autoComplete === void 0 ? true : _ref$autoComplete,
    subLabel = _ref.subLabel,
    disabled = _ref.disabled,
    _onBlur = _ref.onBlur,
    _onFocus = _ref.onFocus,
    margin = _ref.margin,
    value = _ref.value,
    customcss = _ref.customcss,
    _ref$noIcons = _ref.noIcons,
    noIcons = _ref$noIcons === void 0 ? false : _ref$noIcons,
    _ref$formatType = _ref.formatType,
    formatType = _ref$formatType === void 0 ? 'default' : _ref$formatType,
    inputClassName = _ref.inputClassName,
    fieldId = _ref.fieldId,
    checkAutoFills = _ref.checkAutoFills,
    _ref$wasAutoFilled = _ref.wasAutoFilled,
    wasAutoFilled = _ref$wasAutoFilled === void 0 ? false : _ref$wasAutoFilled,
    addToAutoFillList = _ref.addToAutoFillList,
    runValidation = _ref.runValidation,
    props = _objectWithoutProperties(_ref, _excluded)

  // we set the different states manually so we have total control
  // but a custom disabled prop can be passed that will override this one
  var _useState = (0, _react2.useState)({
      focused: false,
      disabled: false,
    }),
    _useState2 = _slicedToArray(_useState, 2),
    inputState = _useState2[0],
    setInputState = _useState2[1]

  var focused = inputState.focused,
    isDisabled = inputState.disabled // manages the "saved" & "saving" indicator on the input

  var _useState3 = (0, _react2.useState)({
      _saving: false,
      saved: false,
      valueToSave: '',
      lastSavedValue: '',
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    saveState = _useState4[0],
    setSaveState = _useState4[1]

  var _saving = saveState._saving,
    saved = saveState.saved,
    valueToSave = saveState.valueToSave,
    lastSavedValue = saveState.lastSavedValue // this var keeps track of the actual field value when
  // masking inputs for sensitive fields on blur.

  var _useState5 = (0, _react2.useState)(value),
    _useState6 = _slicedToArray(_useState5, 2),
    realValue = _useState6[0],
    setRealValue = _useState6[1]

  var toMaskedValue = function toMaskedValue(val) {
    return !val
      ? ''
      : _toConsumableArray(val)
          .filter(function (_char) {
            return _char !== '-'
          })
          .map(function () {
            return '*'
          })
          .reduce(function (acc, cur) {
            return acc + cur
          })
  }
  /*
    we want the ability to save data on blur, so we set
    the input / save state here & call the save function if it exists
  */

  var saveData = /*#__PURE__*/ (function () {
    var _ref2 = _asyncToGenerator(
      /*#__PURE__*/ regeneratorRuntime.mark(function _callee(val) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch ((_context.prev = _context.next)) {
              case 0:
                if (!(onSave && val !== lastSavedValue)) {
                  _context.next = 5
                  break
                }

                setSaveState(
                  _objectSpread(
                    _objectSpread({}, saveState),
                    {},
                    {
                      _saving: true,
                      saved: false,
                    }
                  )
                )
                setInputState(
                  _objectSpread(
                    _objectSpread({}, inputState),
                    {},
                    {
                      disabled: true,
                    }
                  )
                )
                _context.next = 5
                return onSave(val)

              case 5:
                setSaveState(
                  _objectSpread(
                    _objectSpread({}, saveState),
                    {},
                    {
                      _saving: false,
                      saved: !!val,
                      lastSavedValue: val,
                    }
                  )
                )
                setInputState(
                  _objectSpread(
                    _objectSpread({}, inputState),
                    {},
                    {
                      disabled: false,
                    }
                  )
                )

              case 7:
              case 'end':
                return _context.stop()
            }
          }
        }, _callee)
      })
    )

    return function saveData(_x) {
      return _ref2.apply(this, arguments)
    }
  })()

  ;(0, _react2.useEffect)(
    function () {
      if (wasAutoFilled && !!value) {
        setSaveState(
          _objectSpread(
            _objectSpread({}, saveState),
            {},
            {
              valueToSave: value,
            }
          )
        )
        runValidation && runValidation(value)
      }
    },
    [wasAutoFilled, value]
  )
  ;(0, _react2.useEffect)(
    function () {
      // save value only if it changed and no errors are present
      if (!error) {
        saveData(valueToSave)
      }

      if (value !== realValue) setRealValue(value) // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [valueToSave, value]
  )
  var saveNotProcessing = !saved && !saving && !_saving

  var renderInput = function renderInput() {
    return as === 'textarea'
      ? /*#__PURE__*/ _react2['default'].createElement(
          StyledTextarea,
          _extends(
            {
              id: fieldId || id,
              error: error,
              required: required,
              disabled: disabled || isDisabled,
              onFocus: function onFocus(e) {
                _onFocus && _onFocus(e)
                setInputState(
                  _objectSpread(
                    _objectSpread({}, inputState),
                    {},
                    {
                      focused: true,
                    }
                  )
                )
              },
              onBlur: function onBlur(e) {
                // react-use-form-state does some validation on blur
                _onBlur && _onBlur(e)
                setInputState(
                  _objectSpread(
                    _objectSpread({}, inputState),
                    {},
                    {
                      focused: false,
                    }
                  )
                )
                setSaveState(
                  _objectSpread(
                    _objectSpread({}, saveState),
                    {},
                    {
                      valueToSave: e.target.value,
                    }
                  )
                )
              },
              value: value,
              onChange: function onChange(e) {
                _onChange && _onChange(e)
              },
            },
            props
          )
        )
      : /*#__PURE__*/ _react2['default'].createElement(
          StyledInput,
          _extends(
            {
              id: fieldId || id,
              error: error,
              required: required,
              disabled: disabled || isDisabled,
              autoComplete: autoComplete ? 'on' : 'off',
              options: cleaveOptions[formatType],
              onAnimationStart: function onAnimationStart() {
                addToAutoFillList && addToAutoFillList()
              },
              onFocus: function onFocus(e) {
                _onFocus && _onFocus(e)
                setInputState(
                  _objectSpread(
                    _objectSpread({}, inputState),
                    {},
                    {
                      focused: true,
                    }
                  )
                )
              },
              onChange: function onChange(e) {
                // keep track of real value for when we mask the field on blur
                setRealValue(e.target.value)
                _onChange && _onChange(e)
              },
              onBlur: function onBlur(e) {
                // react-use-form-state does some validation on blur
                _onBlur && _onBlur(e)
                setInputState(
                  _objectSpread(
                    _objectSpread({}, inputState),
                    {},
                    {
                      focused: false,
                    }
                  )
                )
                setSaveState(
                  _objectSpread(
                    _objectSpread({}, saveState),
                    {},
                    {
                      valueToSave: e.target.value,
                    }
                  )
                )
                checkAutoFills && checkAutoFills(e.target.id) // console.log('se esta ejecutando el onBLur')
              },
              value: formatType === 'SSN' && !focused ? toMaskedValue(realValue) : realValue,
              customcss: customcss,
            },
            props
          )
        )
  }

  return /*#__PURE__*/ _react2['default'].createElement(
    _index3.Flex,
    {
      flex: '1',
      flexDirection: 'column',
      margin: margin,
    },
    label &&
      /*#__PURE__*/ _react2['default'].createElement(
        _index.Label,
        {
          htmlFor: id,
          error: !!error,
          required: required,
          disabled: disabled || isDisabled,
          className: 'fs-unmask',
        },
        label,
        ' ',
        subLabel &&
          /*#__PURE__*/ _react2['default'].createElement(
            'span',
            {
              className: 'sub-label',
            },
            '(',
            subLabel,
            ')'
          )
      ),
    /*#__PURE__*/ _react2['default'].createElement(
      'div',
      {
        style: {
          position: 'relative',
          height: 45,
        },
        className: inputClassName,
      },
      renderInput(),
      Icon &&
        (focused || saveNotProcessing) &&
        /*#__PURE__*/ _react2['default'].createElement(CustomIconContainer, null, Icon),
      (_saving || saving) &&
        /*#__PURE__*/ _react2['default'].createElement(
          InputIcon,
          null,
          /*#__PURE__*/ _react2['default'].createElement(SavingIndicator, null, 'Saving...')
        ),
      realValue &&
        saved &&
        !focused &&
        !disabled &&
        !noIcons &&
        /*#__PURE__*/ _react2['default'].createElement(
          InputIcon,
          null,
          /*#__PURE__*/ _react2['default'].createElement(SuccessIcon, null)
        ),
      error &&
        !focused &&
        !disabled &&
        !noIcons &&
        /*#__PURE__*/ _react2['default'].createElement(
          InputIcon,
          null,
          /*#__PURE__*/ _react2['default'].createElement(ErrorIcon, null)
        )
    ),
    /*#__PURE__*/ _react2['default'].createElement(
      ErrorContainer,
      {
        justifyContent: 'flex-end',
        error: error,
      },
      /*#__PURE__*/ _react2['default'].createElement(
        _index2.Typography,
        {
          color: 'error',
          as: 'label',
          htmlFor: id,
        },
        error || 'invisible text to force height'
      )
    )
  )
}

exports.TextField = TextField
var Formats
;(function (Formats) {
  Formats[(Formats['Phone_Number'] = 0)] = 'Phone_Number'
  Formats[(Formats['SSN'] = 1)] = 'SSN'
  Formats[(Formats['Date_Input'] = 2)] = 'Date_Input'
  Formats[(Formats['Time_Input'] = 3)] = 'Time_Input'
  Formats[(Formats['Number_Input'] = 4)] = 'Number_Input'
  Formats[(Formats['Currency_Input'] = 5)] = 'Currency_Input'
  Formats[(Formats['default'] = 6)] = 'default'
})(Formats || (Formats = {}))

var cleaveOptions = {
  Phone_Number: {
    phone: true,
    phoneRegionCode: 'US',
  },
  SSN: {
    blocks: [3, 2, 4],
    delimiter: '-',
  },
  Date_Input: {
    date: true,
    datePattern: ['m', 'd', 'Y'],
  },
  Time_Input: {
    time: true,
    timePattern: ['h', 'm'],
  },
  Number_Input: {
    numericOnly: true,
    blocks: [10, 10],
  },
  Currency_Input: {
    numeral: true,
    prefix: '$',
    rawValueTrimPrefix: true,
    noImmediatePrefix: true,
    numeralThousandsGroupStyle: 'thousand',
  },
  default: {
    delimiter: '',
  },
}
/****************************** PRINTABLE COMPONENTS **************************/

var FONT_SIZE_FACTOR = 6

var getSize = function getSize(size) {
  return size === 'sm' ? 45 : size === 'md' ? 75 : 95
}

var PrintedTextField = function PrintedTextField(_ref3) {
  var _ref3$size = _ref3.size,
    size = _ref3$size === void 0 ? 'md' : _ref3$size,
    label = _ref3.label,
    value = _ref3.value
  var labelWidth = label.length * FONT_SIZE_FACTOR
  var minWidth = labelWidth + (0, _conversion.mmToPixel)(getSize(size))
  return /*#__PURE__*/ _react2['default'].createElement(
    _index3.Flex,
    {
      flex: '2',
      flexWrap: 'wrap',
      alignItems: 'flex-end',
      margin: '12px 12px 0px 0px',
      minWidth: ''.concat(minWidth, 'px'),
    },
    /*#__PURE__*/ _react2['default'].createElement(StyledLabel, null, label, ':'),
    /*#__PURE__*/ _react2['default'].createElement(
      StyledValue,
      {
        flex: 1,
      },
      value
    )
  )
}

exports.PrintedTextField = PrintedTextField

var PrintedTextAreaField = function PrintedTextAreaField(_ref4) {
  var label = _ref4.label,
    value = _ref4.value
  return /*#__PURE__*/ _react2['default'].createElement(
    _index3.Flex,
    {
      minWidth: '100%',
      flexDirection: 'column',
      margin: '2 0 2 0',
    },
    /*#__PURE__*/ _react2['default'].createElement(StyledLabel, null, label, ':'),
    /*#__PURE__*/ _react2['default'].createElement(
      StyledValue,
      {
        flex: 1,
        style: {
          textAlign: 'left',
        },
      },
      value
    )
  )
}

exports.PrintedTextAreaField = PrintedTextAreaField

var PrintedSSNField = function PrintedSSNField(_ref5) {
  var label = _ref5.label,
    value = _ref5.value
  var labelWidth = label.length * FONT_SIZE_FACTOR
  var minWidth = labelWidth + (0, _conversion.mmToPixel)(45)
  var a,
    b,
    c = ''

  if (value) {
    var splitValue = value.split('-')
    a = splitValue[0]
    b = splitValue[1]
    c = splitValue[2]
  }

  return /*#__PURE__*/ _react2['default'].createElement(
    _index3.Flex,
    {
      flex: '1',
      alignItems: 'center',
      margin: '12px 12px 0px 0px',
      minWidth: ''.concat(minWidth, 'px'),
    },
    /*#__PURE__*/ _react2['default'].createElement(StyledLabel, null, label, ':'),
    /*#__PURE__*/ _react2['default'].createElement(
      StyledValue,
      {
        flex: 1,
      },
      a
    ),
    /*#__PURE__*/ _react2['default'].createElement(Hyphen, null),
    /*#__PURE__*/ _react2['default'].createElement(
      StyledValue,
      {
        flex: 1,
      },
      b
    ),
    /*#__PURE__*/ _react2['default'].createElement(Hyphen, null),
    /*#__PURE__*/ _react2['default'].createElement(
      StyledValue,
      {
        flex: 1,
      },
      c
    )
  )
}

exports.PrintedSSNField = PrintedSSNField

var PrintedPhoneField = function PrintedPhoneField(_ref6) {
  var label = _ref6.label,
    value = _ref6.value
  var labelWidth = label.length * FONT_SIZE_FACTOR
  var minWidth = labelWidth + (0, _conversion.mmToPixel)(45)
  var a,
    b,
    c = ''

  if (value) {
    value = value.replace(/ /g, '')
    a = value.slice(0, 3)
    b = value.slice(3, 6)
    c = value.slice(6, 10)
  }

  return /*#__PURE__*/ _react2['default'].createElement(
    _index3.Flex,
    {
      flex: '1',
      alignItems: 'flex-end',
      margin: '12px 12px 0px 0px',
      minWidth: ''.concat(minWidth, 'px'),
    },
    /*#__PURE__*/ _react2['default'].createElement(StyledLabel, null, label, ':'),
    '(',
    /*#__PURE__*/ _react2['default'].createElement(
      StyledValue,
      {
        flex: 1,
      },
      a
    ),
    ')',
    /*#__PURE__*/ _react2['default'].createElement(
      StyledValue,
      {
        flex: 1,
      },
      b
    ),
    /*#__PURE__*/ _react2['default'].createElement(
      StyledValue,
      {
        flex: 1.5,
      },
      c
    )
  )
}

exports.PrintedPhoneField = PrintedPhoneField

var Hyphen = _styledComponents['default'].div(
  _templateObject9 ||
    (_templateObject9 = _taggedTemplateLiteral([
      '\n  background-color: black;\n  width: 2mm;\n  height: 1px;\n',
    ]))
)

var StyledValue = _styledComponents['default'].div(
  _templateObject10 ||
    (_templateObject10 = _taggedTemplateLiteral([
      '\n  font-weight: bold;\n  border-bottom: 1px solid black;\n  text-align: center;\n  ',
      ';\n  min-height: 20px;\n',
    ])),
  function (props) {
    return props.flex && 'flex: '.concat(props.flex, ';')
  }
)

exports.StyledValue = StyledValue

var StyledLabel = _styledComponents['default'].span(
  _templateObject11 ||
    (_templateObject11 = _taggedTemplateLiteral(['\n  padding-right: 4px;\n  max-width: 350px;\n']))
)
